import { Navigate, Route, Routes, useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

import { getDictionary } from '@up2promo-setup-frontend/dictionary';
import { DictionaryProvider } from '@up2promo-setup-frontend/ui/providers/dictionary.provider';
import Providers from '@up2promo-setup-frontend/ui/providers/providers';
import { detectBrowserLocale } from './core/utils/locale.utils';
import NotFoundPage from './pages/NotFoundPage';
import ResetPage from './pages/ResetPage';
import SetupLayout from './pages/setup/SetupLayout';
import WelcomePage from './pages/setup/WelcomePage';
import EmailPage from './pages/setup/EmailPage';
import SelectTypePage from './pages/setup/SelectTypePage';
import InputPage from './pages/setup/InputPage';
import AddressPage from './pages/setup/AddressPage';
import SelectSuggestionPage from './pages/setup/SelectSuggestionPage';
import CustomUrlPage from './pages/setup/CustomUrlPage';
import CongratsPage from './pages/setup/CongratsPage';

// Component to handle redirect from /:hash to /:hash/welcome while preserving query params
function SetupIndexRedirect() {
  const [searchParams] = useSearchParams();
  const search = searchParams.toString();
  const searchString = search ? `?${search}` : '';
  return <Navigate to={`welcome${searchString}`} replace />;
}

function App() {
  // Detect browser locale (no path-based routing)
  const locale = useMemo(() => detectBrowserLocale(), []);
  const dictionary = useMemo(() => getDictionary(locale), [locale]);

  return (
    <DictionaryProvider dictionary={dictionary} lang={locale}>
      <Providers>
        <Routes>
          <Route path="/" element={<NotFoundPage />} />
          <Route path="/reset/:resetCode" element={<ResetPage />} />
          <Route path="/:hash" element={<SetupLayout />}>
            <Route index element={<SetupIndexRedirect />} />
            <Route path="welcome" element={<WelcomePage />} />
            <Route path="email" element={<EmailPage />} />
            <Route path="select-type" element={<SelectTypePage />} />
            <Route path="input" element={<InputPage />} />
            <Route path="address" element={<AddressPage />} />
            <Route
              path="select-suggestion"
              element={<SelectSuggestionPage />}
            />
            <Route path="custom-url" element={<CustomUrlPage />} />
            <Route path="congrats" element={<CongratsPage />} />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Providers>
    </DictionaryProvider>
  );
}

export default App;
